import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { LuMessageCircle, LuX, LuMail, LuPhone } from 'react-icons/lu';

export const WhatsAppFloat = () => {
  const [isOpen, setIsOpen] = useState(false);

  const contactOptions = [
    {
      type: 'whatsapp',
      url: 'https://wa.me/919152929786?text=Hi%20TechMeetsU%2C%20I%20would%20like%20to%20connect%20with%20you',
      label: 'Sales & Inquiries',
      display: '+91 91529 29786',
      icon: 'whatsapp',
      color: 'from-green-600 to-green-500',
      hoverColor: 'hover:from-green-500 hover:to-green-400',
      shadow: 'hover:shadow-green-500/50'
    },
    {
      type: 'whatsapp',
      url: 'https://wa.me/919152978629?text=Hi%20TechMeetsU%2C%20I%20would%20like%20to%20connect%20with%20you',
      label: 'Support & Services',
      display: '+91 91529 78629',
      icon: 'whatsapp',
      color: 'from-green-600 to-green-500',
      hoverColor: 'hover:from-green-500 hover:to-green-400',
      shadow: 'hover:shadow-green-500/50'
    },
    {
      type: 'email',
      url: 'mailto:admin@techmeetsu.com?subject=Inquiry%20from%20Website&body=Hi%20TechMeetsU%2C%0A%0AI%20would%20like%20to%20connect%20with%20you%20regarding%3A%0A%0A',
      label: 'Email Us',
      display: 'admin@techmeetsu.com',
      icon: 'email',
      color: 'from-blue-600 to-blue-500',
      hoverColor: 'hover:from-blue-500 hover:to-blue-400',
      shadow: 'hover:shadow-blue-500/50'
    }
  ];

  return (
    <div className="fixed bottom-24 right-4 md:bottom-8 md:right-6 z-50" data-testid="whatsapp-float">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.8 }}
            className="mb-4 bg-slate-900/98 backdrop-blur-xl border border-slate-700/50 rounded-3xl p-5 shadow-2xl min-w-[280px] md:min-w-[320px]"
          >
            {/* Header */}
            <div className="flex items-center justify-between mb-5">
              <div>
                <h3 className="font-heading font-bold text-white text-base">Connect with Us</h3>
                <p className="text-xs text-slate-400">We're here to help!</p>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="text-slate-400 hover:text-white transition-colors p-1.5 rounded-lg hover:bg-slate-800/50"
                data-testid="close-contact-menu"
              >
                <LuX size={20} />
              </button>
            </div>

            {/* Contact Options */}
            <div className="space-y-3">
              {contactOptions.map((contact, index) => (
                <motion.a
                  key={index}
                  href={contact.url}
                  target={contact.type === 'email' ? '_self' : '_blank'}
                  rel="noopener noreferrer"
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className={`flex items-center gap-3 bg-gradient-to-r ${contact.color} ${contact.hoverColor} text-white px-4 py-3.5 rounded-2xl transition-all shadow-lg ${contact.shadow} mb-3`}
                  data-testid={`contact-link-${index}`}
                >
                  {contact.icon === 'whatsapp' ? (
                    <svg className="w-6 h-6 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                    </svg>
                  ) : (
                    <LuMail className="w-6 h-6 flex-shrink-0" />
                  )}
                  <div className="flex-1 text-left min-w-0">
                    <div className="text-[10px] opacity-90 font-medium uppercase tracking-wider">{contact.label}</div>
                    <div className="text-sm font-bold truncate">{contact.display}</div>
                  </div>
                </motion.a>
              ))}
            </div>

            {/* Quick Call Option */}
            <div className="mt-4 pt-4 border-t border-slate-700/50">
              <a
                href="tel:+919152929786"
                className="flex items-center justify-center gap-2 text-slate-400 hover:text-orange-400 transition-colors text-sm"
              >
                <LuPhone size={16} />
                <span>Or call us directly</span>
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main Button */}
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => setIsOpen(!isOpen)}
        className="relative bg-gradient-to-r from-green-600 to-green-500 hover:from-green-500 hover:to-green-600 text-white w-14 h-14 md:w-16 md:h-16 rounded-full shadow-2xl flex items-center justify-center transition-all hover:shadow-green-500/50"
        data-testid="contact-button"
      >
        {/* Pulse animation ring */}
        {!isOpen && (
          <motion.span
            className="absolute inset-0 rounded-full bg-green-500/30"
            animate={{ scale: [1, 1.5, 1.5], opacity: [0.5, 0, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
          />
        )}

        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
        >
          {isOpen ? (
            <LuX size={26} />
          ) : (
            <LuMessageCircle size={26} />
          )}
        </motion.div>
      </motion.button>
    </div>
  );
};
